const links = document.querySelectorAll(".js-material a");
links.forEach((link) => {
  //   console.log(link);
  link.addEventListener("click", (e) => {
    e.preventDefault();
    const modal = document.querySelector(".popup-certifications");
    if (modal) modal.style.display = "block";

    fetch(`${e.target.closest("a").href}?section_id=page__main`)
      .then((response) => {
        if (response.ok) return response.text();

        return response.json().then((data) => {
          throw new Error(data?.message || "Somethinf went wrong !");
        });
      })
      .then((posts) => {
        const innHTML = new DOMParser().parseFromString(posts, "text/html");
        const imgElements = innHTML.querySelectorAll(".page__content img");
        console.log(imgElements);
        imgElements.forEach(imgElement => {
          document.querySelector("#popup_certifi").appendChild(imgElement);
        });

      })
      .catch((error) => {
        console.log(error);
      });
  });
});

function removeImgPopup() {
  const imgPopups = document.querySelectorAll(".popup_certifi-inner img");
  imgPopups.forEach(imgPopup => {
    imgPopup.remove();
  });
}

function modal() {
  const modal = document.querySelector(".popup-certifications");

  const btnClose = modal.querySelector(".modal-times");

  // When the user clicks on btnClose x, close the modal
  if (btnClose) {
    btnClose.addEventListener("click", () => {
      modal.style.display = "none";
      removeImgPopup();
    });
  }

  // When the user clicks anywhere outside of the modal, close it
  window.addEventListener("click", (event) => {
    // console.log(event.target);
    if (event.target == modal) {
      modal.style.display = "none";
      removeImgPopup();
    }
  });
}

modal();
